import { css } from '@emotion/core'
import { colors } from '@bonitour/components'

export const iconCss = css`
  font-size: 1.5rem;
  color: ${colors.gray4};
  cursor: pointer;
`

export const dialogContainer = css`
  max-width: 520px;
  max-height: 100vh;
  overflow: auto;
`
